import { PortalComponent } from '~/lib/contexts/ComponentPortalContext';
import { NoteStatus } from '~/lib/constants/AddPatientNoteModal.constants';
import EditNoteAccordion from '~/components/maud/patients/note/EditNoteAccordion';
import ViewGroupClassNoteAccordion from '~/components/maud/patients/note/ViewGroupClassNoteAccordion';

export interface ComponentPortalNoteAccordionData {
  appointmentDetails?: AppointmentDetailResponse;
  existingNoteId?: string;
  existingNoteStatus?: NoteStatus; // currently only used for group class "view notes accordion" check
  groupClassEventExternalId?: string;
  groupClassEventTitle?: string;
  isAddNote?: boolean; // is really a proxy for sometimes opening the view group class note accordion instead. would be better to just open that explicitly
}

type Props = {
  data: ComponentPortalNoteAccordionData;
  isExpanded: boolean;
  dismissAccordion: (component: PortalComponent) => void;
  currentPatientId: string;
  setComponentVisibility: (props: any) => void;
};
export const NoteAccordionComponentChooser = ({
  data,
  currentPatientId,
  isExpanded,
  dismissAccordion,
  setComponentVisibility,
}: Props) => {
  const commonAccordionProps = {
    isExpanded,
    setIsExpanded: (isExpanded: boolean) => {
      setComponentVisibility({
        component: PortalComponent.NOTE_ACCORDION,
        isExpanded,
      });
    },
  };
  if (
    data?.groupClassEventExternalId &&
    data.existingNoteStatus === NoteStatus.SIGNED
  ) {
    return (
      <ViewGroupClassNoteAccordion
        {...commonAccordionProps}
        dismissViewNote={() => dismissAccordion(PortalComponent.NOTE_ACCORDION)}
        groupClassEventExternalId={data.groupClassEventExternalId}
      />
    );
  }
  return (
    <EditNoteAccordion
      {...commonAccordionProps}
      appointmentDetails={data?.appointmentDetails}
      dismissAccordion={() => {
        dismissAccordion(PortalComponent.NOTE_ACCORDION);
      }}
      existingNoteId={data?.existingNoteId}
      groupClassEventExternalId={data?.groupClassEventExternalId}
      groupClassEventTitle={data?.groupClassEventTitle}
      patientId={currentPatientId}
    />
  );
};
